/* eslint-disable  jsx-a11y/label-has-associated-control,  no-nested-ternary */ 
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import { Button } from '@material-ui/core';
// import CustomButton from '../components/button/View';
import CustomButton  from '../components/button/View';
import NewCustomButton  from 'components_newui/customButton/CustomButton';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    basicDetailWrp: {
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title: {
        fontFamily: 'VodafoneRg-Regular',
        fontSize: '1.25rem',
        margin: '0 0 2rem 0',
        textAlign: 'left',
        color: "#333",
    },
    fieldsetBox: {
        marginBottom: theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label': {
            fontFamily: 'VodafoneRg-bold',
            fontSize: '1rem',
            margin: '0 0 0.5rem 0',
            textAlign: 'left',
            color: "#333",
            display: 'block',
        },
        '& input[type="text"],input[type="date"],select ': {
            fontFamily: 'VodafoneRg-Regular',
            fontSize: '1rem',
            margin: '0 0 0.5rem 0',
            textAlign: 'left',
            color: "#333",
            background: '#fff',
            borderRadius: '4px',
            width: '100%',
            minHeight: '3rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            height:'48px',
        },
        '& input[type=date]:before': { content: 'none' },
        '& textarea': {
            fontFamily: 'VodafoneRg-Regular',
            fontSize: '1rem',
            margin: '0 0 0.5rem 0',
            textAlign: 'left',
            color: "#333",
            background: '#fff',
            borderRadius: '4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize: 'none'
        },



    },
    '& input[aria-invalid="true"]': {
        borderColor: 'red',
    },
    error: {
        color: "red",
        fontFamily: 'VodafoneRg-Regular',
        fontSize: '1rem',
        margin: '0 0 0.5rem 0',
    },
    labelname: {
        fontFamily: 'VodafoneRg-bold',
        fontSize: '1rem',
        margin: '0 0 0.5rem 0',
        textAlign: 'left',
        color: "#333",
        display: 'block',
    },

    invalid: {
        borderColor: 'red !important',
    },

    wrp2cols: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem'
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));



const statusArray = [
    { label: "ACTIVE", value: "Active" },
    { label: "Not New", value: "Not_New" },
    { label: "Evaluating", value: "Evaluating" },
    { label: "Investigating", value: "Investigating" },
    { label: "Incubating", value: "Incubating" },
    { label: "Implemented", value: "Implemented" },
    { label: "Implementing", value: "Implementing" },
    { label: "Implemented with PIR", value: "Implemented_PIR" },
    { label: "Backlog", value: "Backlog" },
    { label: "No Apetite", value: "No_Apetite" },
    { label: "Selected for hackathon", value: "Selected_For_Hackathon" },
    { label: "Idea Closed", value: "Idea_Closed" }
];


const IdeaApprove = ({ showPopupScorecardIsLoading,isHackathonChallenge,status, postIdeaApproveAPIfn , ideaIdKey, postApproveIdeaIsLoading, innovateUserIsEvaluatorOrNot, onEvaluateScorecard, onEvaluateBusinessScorecard,filteredDataGetListEvaluatorAssignedIdea, setDialogOpenApprove }) => {
    const classes = useStyles()

    const [ideaStatus, setIdeaStatus] = useState(status || "");
    const [comment, setComment] = useState("");
    // const [check_innovateUserIsEvaluatorOrNot, setCheck_innovateUserIsEvaluatorOrNot] = useState(innovateUserIsEvaluatorOrNot);

    const handleStatusChange = (e) => setIdeaStatus(e.target.value);
    const handleCommentChange = (e) => setComment(e.target.value)

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //         const formDataCollect ={ 
    //             ideaIdKey,
    //             status: ideaStatus, 
    //             comment 
    //         } ;
    //         console.log("all data", formDataCollect )

    //         postIdeaApproveAPIfn(formDataCollect)
    // };

    // useEffect(()=>{
    //     setCheck_innovateUserIsEvaluatorOrNot((prev)=>prev)
    // },[innovateUserIsEvaluatorOrNot])

// local UI state (if not already present)
// const [submitting, setSubmitting] = useState(false);
const [error, setError] = useState(null);
// const [success, setSuccess] = useState(false);

// Optional: centralized validators
const validatePayload = (
    ideaIdKeyParam,
    ideaStatusParam,
    commentParam
  ) => {
    if (!ideaIdKeyParam)
      return 'Missing ideaIdKey';
  
    if (!ideaStatusParam)
      return 'Select idea status';
  
    if (
      String(ideaStatusParam).toUpperCase() ===
        'REJECTED' &&
      !commentParam?.trim()
    ) {
      return 'Comment is required';
    }
  
    if (commentParam?.length > 1000) {
      return 'Comment exceeds 1000 characters';
    }
  
    return null;
  };


  const handleSubmit = e => {
    e.preventDefault();
    setError(null);
  
    const payload = {
      ideaIdKey: String(ideaIdKey || '').trim(),
      status: String(ideaStatus || '').trim(),
      comment: String(comment || '').trim(),
  
      // use later in confirmation popup
      closeApproveDialog: () => setDialogOpenApprove(false),
    };
  
    const validationError = validatePayload(
      payload.ideaIdKey,
      payload.status,
      payload.comment
    );
  
    if (validationError) {
      setError(validationError);
      return;
    }
  
    postIdeaApproveAPIfn(payload);
  };

    const isFormValid = !!ideaStatus 

    const hasScorecards =
    filteredDataGetListEvaluatorAssignedIdea?.length > 0;
  
  const isScorecardCompleted =
    isHackathonChallenge ||
    !hasScorecards ||
    filteredDataGetListEvaluatorAssignedIdea.every(
      item => !!item.ideaRating
    );
  

    // const isScorecardCompleted =  filteredDataGetListEvaluatorAssignedIdea?.every(
    //     (item) => !!item.ideaRating
    // );
    
// console.log("check_innovateUserIsEvaluatorOrNot===>", check_innovateUserIsEvaluatorOrNot)
// console.log("innovateUserIsEvaluatorOrNot===>", innovateUserIsEvaluatorOrNot)

    return (
        <div>

             {/* when isHackathonChallenge=false is true than hide  scorecard and business button for hackthon periods */}
            { isHackathonChallenge ? null :
            <div>
            <p>Before approving and changing the idea status, please Evaluate the scorecard.</p>
                
                {filteredDataGetListEvaluatorAssignedIdea?.map((item, index) => (
                    <div key={item?.id}>
                        {/* {console.log("submit json popup==>item",item)} */}
                        {status !== "DRAFT" && innovateUserIsEvaluatorOrNot ? (
                            item.businessScoreCardFlag === "B" ? (<>
                                <CustomButton
                                    bgColor={!item.ideaRating ? '#6d45ff' : '#008000'}
                                    btnDisable={showPopupScorecardIsLoading}
                                    text={showPopupScorecardIsLoading ? 'Loading...' : "Business Scorecard" }
                                    action={() => onEvaluateBusinessScorecard(item)} />  
                               <span 
                                style={{
                                    fontSize:'12px',
                                    color:item.ideaRating ?  '#008000' :'#333'
                                }}
                            >
                                {!item.ideaRating ? 'Not rated yet' : 'Your rating has been completed'}</span>
                                
                                </>) : item.businessScoreCardFlag === "E" ? (<>
                                <CustomButton
                                    bgColor={!item.ideaRating ? '#6d45ff' : '#008000'}
                                    text={showPopupScorecardIsLoading ? 'Loading...' : "Evaluator Scorecard"}
                                    btnDisable={showPopupScorecardIsLoading}
                                    action={() => onEvaluateScorecard(item)} />
                            <span 
                                style={{
                                    fontSize:'12px',
                                    color:item.ideaRating ?  '#008000' :'#333'
                                }}
                            >
                                {!item.ideaRating ? 'Not rated yet' : 'Your rating has been completed'}</span> </>) : (
                                <span>No scorecard available</span>
                            )
                        ) : (
                            <span>No scorecard available</span>
                        )}
                    </div>
                ))}
            </div>
            }
             <form onSubmit={handleSubmit}>
                <fieldset className={classes.fieldsetBox}>

                    <label htmlFor='ideaStatus'>Select Your Idea Status</label>
                    <select
                        name="ideaStatus"
                        id="ideaStatus"
                        value={ideaStatus}
                        onChange={handleStatusChange}
                        disabled={!isScorecardCompleted}
                    >
                        <option value="">Select...</option>
                        {statusArray.map(type => (
                            <option key={type.value} value={type.value}>
                                {type.label}
                            </option>
                        ))}
                    </select>
                </fieldset>

                <fieldset className={classes.fieldsetBox}>
                    <label htmlFor='Comment'>Comment - Be aware, these comments will be visible to the idea owner.</label>
                    <textarea
                        name="Comment"
                        id='Comment'
                        placeholder='idea Comment'
                        value={comment}
                        onChange={handleCommentChange}
                        disabled={!isScorecardCompleted}
                    />
                </fieldset>
               { error && <p style={{color:'red'}}>{error}</p> }
               {!isScorecardCompleted && (
                <p style={{ color: 'red', marginBottom: '10px' }}>
                    Please complete all scorecards before changing the idea status.
                </p>
                )}

                {/* <Button onClick={handleSubmit}  variant="contained" disabled={!isFormValid || postApproveIdeaIsLoading || !isScorecardCompleted}  style={{ marginLeft: '10px' }} color="primary">  {postApproveIdeaIsLoading ? "Loading..." : "Approve"}  </Button> */}
                <NewCustomButton
                type="submit"
                variant="contained"
                color="primary"
                disabled={
                    !isFormValid ||
                    postApproveIdeaIsLoading ||
                    !isScorecardCompleted
                }
                >
                {postApproveIdeaIsLoading
                    ? 'Loading...'
                    : 'Approve'}
                </NewCustomButton>

            </form>
        </div>
    )
}

export default IdeaApprove;
